import { JiraServiceManagementIcon } from '@atlaskit/logo';

import { whyAmISeeingThisRecommendationMessageDefaultReason } from '@post-office/components--ad-controls';

import { JiraSideNavFirstPartyRecommendation } from '@post-office/components--jira-side-nav-first-party-recommendation';

import { FormattedMessage } from 'react-intl';

import { createRender } from './types';

import { type JSX } from 'react/jsx-runtime';

import { CCP_PRODUCT_ID, HAMS_PRODUCT_ID, PRODUCT_NAME } from '../../../common/constants';

import { registeredContent } from './content';

const whyAmISeeingThisModalContent = {
	message: (
		<p>
			<FormattedMessage
				{...registeredContent.default.reasonsModalMessage}
				values={{ jsm: <strong>{PRODUCT_NAME}</strong> }}
			/>
		</p>
	),
	reasons: whyAmISeeingThisRecommendationMessageDefaultReason,
};

export type Props = {
	onDismissed: (messageInstanceId: string) => void;
};

export const render: (renderProps: { onDismissed: () => void }) => JSX.Element | null =
	createRender(({ onDismissed }: Props) => (
		<JiraSideNavFirstPartyRecommendation
			app={{
				hamsIdentifier: HAMS_PRODUCT_ID,
				ccpProductId: CCP_PRODUCT_ID,
				logo: <JiraServiceManagementIcon appearance="brand" />,
				header: <FormattedMessage {...registeredContent.default.header} />,
				ctaMessage: <FormattedMessage {...registeredContent.default.cta} />,
			}}
			onDismissed={onDismissed}
			whyAmISeeingThisModalContent={whyAmISeeingThisModalContent}
		/>
	));

export default render;
